const r = {
  xsmall: 0,
  small: 768,
  medium: 1024,
  large: 1320,
  xlarge: 1920
}, t = (n, e) => n in r ? `@media (min-width: ${r[n]}px) { ${e} }` : "", i = (n, e) => n in r ? `@media (max-width: ${r[n] - 1}px) { ${e} }` : "";
export {
  i as down,
  r as screens,
  t as up
};
